<template>
  <div class="info-container normal-font">

    <div class="row justify-end">
      <q-btn
          round
          dense
          flat
          icon="close"
          color="primary"
          @click="router.back()"
      />
    </div>
    <h5>Impressum & Datenschutz&shy;erkl&auml;rung</h5>

    <h5>Impressum</h5>
    <p>
      Verantwortlich für den Inhalt dieser Website:<br>
      <strong>Philip Spahn</strong><br>
      Alt-Heddernheim 43<br>
      60439 Frankfurt am Main<br>
      Deutschland
    </p>
    <p>
      Telefon: 0176 30734651<br>
      E-Mail: <a href="mailto:philip20794@gmail.com">philip20794@gmail.com</a>
    </p>

    <h5>Datenschutz&shy;erkl&auml;rung</h5>
    <h5>1. Datenschutz auf einen Blick</h5>
    <h5>Allgemeine Hinweise</h5>
    <p>
      Die folgenden Hinweise geben einen einfachen &Uuml;berblick dar&uuml;ber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
      Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie pers&ouml;nlich identifiziert werden k&ouml;nnen.
      Ausf&uuml;hrliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgef&uuml;hrten
      Datenschutzerkl&auml;rung.
    </p>
    <h5>Datenerfassung auf dieser Website</h5>
    <h5>Wer ist verantwortlich f&uuml;r die Datenerfassung auf dieser Website?</h5>
    <p>
      Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten k&ouml;nnen Sie dem Abschnitt
      &bdquo;Hinweis zur Verantwortlichen Stelle&ldquo; in dieser Datenschutzerkl&auml;rung entnehmen.
    </p>
    <h5>Wie erfassen wir Ihre Daten?</h5>
    <p>
      Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.&nbsp;B. um Daten handeln, die Sie in
      ein Kontaktformular eingeben.
    </p>
    <p>
      Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem
      technische Daten (z.&nbsp;B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt
      automatisch, sobald Sie diese Website betreten.
    </p>
    <h5>Wof&uuml;r nutzen wir Ihre Daten?</h5>
    <p>
      Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gew&auml;hrleisten. Andere Daten k&ouml;nnen zur
      Analyse Ihres Nutzerverhaltens verwendet werden. Sofern &uuml;ber die Website Vertr&auml;ge geschlossen oder angebahnt werden
      k&ouml;nnen, werden die &uuml;bermittelten Daten auch f&uuml;r Vertragsangebote, Bestellungen oder sonstige Auftragsanfragen
      verarbeitet.
    </p>
    <h5>Welche Rechte haben Sie bez&uuml;glich Ihrer Daten?</h5>
    <p>
      Sie haben jederzeit das Recht, unentgeltlich Auskunft &uuml;ber Herkunft, Empf&auml;nger und Zweck Ihrer gespeicherten personenbezogenen
      Daten zu erhalten. Sie haben au&szlig;erdem ein Recht, die Berichtigung oder L&ouml;schung dieser Daten zu verlangen. Wenn Sie eine
      Einwilligung zur Datenverarbeitung erteilt haben, k&ouml;nnen Sie diese Einwilligung jederzeit f&uuml;r die Zukunft widerrufen.
      Au&szlig;erdem haben Sie das Recht, unter bestimmten Umst&auml;nden die Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen
      Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zust&auml;ndigen Aufsichtsbeh&ouml;rde zu.
    </p>
    <p>Hierzu sowie zu weiteren Fragen zum Thema Datenschutz k&ouml;nnen Sie sich jederzeit an uns wenden.</p>

    <h5>2. Hosting</h5>
    <p>Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>
    <h5>Squarespace</h5>
    <p>Anbieter ist die Squarespace Ireland Ltd., Le Pole House, Ship Street Great, Dublin 8, Irland (nachfolgend Squarespace).</p>
    <p>
      Squarespace ist ein Tool zum Erstellen und zum Hosten von Websites. Wenn Sie unsere Website besuchen, werden Ihre Daten auf den Servern
      von Squarespace verarbeitet. Hierbei k&ouml;nnen auch personenbezogene Daten an das Mutterunternehmen von Squarespace, die Squarespace
      Inc., 8 Clarkson St, New York, NY 10014, USA &uuml;bermittelt werden. Squarespace speichert ferner Cookies, die f&uuml;r die Darstellung
      der Seite und zur Gew&auml;hrleistung der Sicherheit erforderlich sind (notwendige Cookies).
    </p>
    <p>
      Die Verwendung von Squarespace erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer
      m&ouml;glichst zuverl&auml;ssigen Darstellung unserer Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
      Verarbeitung ausschlie&szlig;lich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG, soweit die Einwilligung die
      Speicherung von Cookies oder den Zugriff auf Informationen im Endger&auml;t des Nutzers (z.&nbsp;B. Device-Fingerprinting) im Sinne des
      TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
    </p>
    <p>
      Die Daten&uuml;bertragung in die USA wird auf die Standardvertragsklauseln der EU-Kommission gest&uuml;tzt. Details finden Sie hier:
      <a href="https://support.squarespace.com/hc/de/articles/360000851908-DSGVO-und-Squarespace" target="_blank" rel="noopener noreferrer"
      >https://support.squarespace.com/hc/de/articles/360000851908-DSGVO-und-Squarespace</a
      >.
    </p>
    <p>
      Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
      &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der die Einhaltung europ&auml;ischer Datenschutzstandards bei
      Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese
      Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link:
      <a href="https://www.dataprivacyframework.gov/participant/4774" target="_blank" rel="noopener noreferrer"
      >https://www.dataprivacyframework.gov/participant/4774</a
      >.
    </p>
    <h5>3. Allgemeine Hinweise und Pflicht&shy;informationen</h5>
    <h5>Datenschutz</h5>
    <p>
      Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers&ouml;nlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
      vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl&auml;rung.
    </p>
    <p>
      Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie
      pers&ouml;nlich identifiziert werden k&ouml;nnen. Die vorliegende Datenschutzerkl&auml;rung erl&auml;utert, welche Daten wir erheben und
      wof&uuml;r wir sie nutzen. Sie erl&auml;utert auch, wie und zu welchem Zweck das geschieht.
    </p>
    <p>
      Wir weisen darauf hin, dass die Daten&uuml;bertragung im Internet (z.&nbsp;B. bei der Kommunikation per E-Mail) Sicherheitsl&uuml;cken
      aufweisen kann. Ein l&uuml;ckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht m&ouml;glich.
    </p>
    <h5>Hinweis zur verantwortlichen Stelle</h5>
    <p>Die verantwortliche Stelle f&uuml;r die Datenverarbeitung auf dieser Website ist:</p>
    <p>
      Philip Spahn<br />
      Alt-Heddernheim 43<br />
      60439 Frankfurt am Main
    </p>

    <p>
      Telefon: &#91;Telefonnummer der verantwortlichen Stelle&#93;<br />
      E-Mail: &#91;E-Mail-Adresse der verantwortlichen Stelle&#93;
    </p>
    <p>
      Verantwortliche Stelle ist die nat&uuml;rliche oder juristische Person, die allein oder gemeinsam mit anderen &uuml;ber die Zwecke und
      Mittel der Verarbeitung von personenbezogenen Daten (z.&nbsp;B. Namen, E-Mail-Adressen o. &Auml;.) entscheidet.
    </p>

    <h5>Speicherdauer</h5>
    <p>
      Soweit innerhalb dieser Datenschutzerkl&auml;rung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten
      bei uns, bis der Zweck f&uuml;r die Datenverarbeitung entf&auml;llt. Wenn Sie ein berechtigtes L&ouml;schersuchen geltend machen oder
      eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gel&ouml;scht, sofern wir keine anderen rechtlich zul&auml;ssigen
      Gr&uuml;nde f&uuml;r die Speicherung Ihrer personenbezogenen Daten haben (z.&nbsp;B. steuer- oder handelsrechtliche
      Aufbewahrungsfristen); im letztgenannten Fall erfolgt die L&ouml;schung nach Fortfall dieser Gr&uuml;nde.
    </p>
    <h5>Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website</h5>
    <p>
      Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1
      lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle
      einer ausdr&uuml;cklichen Einwilligung in die &Uuml;bertragung personenbezogener Daten in Drittstaaten erfolgt die Datenverarbeitung
      au&szlig;erdem auf Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die Speicherung von Cookies oder in den Zugriff auf
      Informationen in Ihr Endger&auml;t (z.&nbsp;B. via Device-Fingerprinting) eingewilligt haben, erfolgt die Datenverarbeitung
      zus&auml;tzlich auf Grundlage von &sect; 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur
      Vertragserf&uuml;llung oder zur Durchf&uuml;hrung vorvertraglicher Ma&szlig;nahmen erforderlich, verarbeiten wir Ihre Daten auf
      Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erf&uuml;llung einer rechtlichen
      Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann ferner auf Grundlage unseres
      berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. &Uuml;ber die jeweils im Einzelfall einschl&auml;gigen
      Rechtsgrundlagen wird in den folgenden Abs&auml;tzen dieser Datenschutzerkl&auml;rung informiert.
    </p>
    <h5>Empf&auml;nger von personenbezogenen Daten</h5>
    <p>
      Im Rahmen unserer Gesch&auml;ftst&auml;tigkeit arbeiten wir mit verschiedenen externen Stellen zusammen. Dabei ist teilweise auch eine
      &Uuml;bermittlung von personenbezogenen Daten an diese externen Stellen erforderlich. Wir geben personenbezogene Daten nur dann an
      externe Stellen weiter, wenn dies im Rahmen einer Vertragserf&uuml;llung erforderlich ist, wenn wir gesetzlich hierzu verpflichtet sind
      (z.&nbsp;B. Weitergabe von Daten an Steuerbeh&ouml;rden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der
      Weitergabe haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von Auftragsverarbeitern geben wir
      personenbezogene Daten unserer Kunden nur auf Grundlage eines g&uuml;ltigen Vertrags &uuml;ber Auftragsverarbeitung weiter. Im Falle
      einer gemeinsamen Verarbeitung wird ein Vertrag &uuml;ber gemeinsame Verarbeitung geschlossen.
    </p>
    <h5>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h5>
    <p>
      Viele Datenverarbeitungsvorg&auml;nge sind nur mit Ihrer ausdr&uuml;cklichen Einwilligung m&ouml;glich. Sie k&ouml;nnen eine bereits
      erteilte Einwilligung jederzeit widerrufen. Die Rechtm&auml;&szlig;igkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom
      Widerruf unber&uuml;hrt.
    </p>
    <h5>Widerspruchsrecht gegen die Datenerhebung in besonderen F&auml;llen sowie gegen Direktwerbung (Art. 21 DSGVO)</h5>
    <p>
      WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GR&Uuml;NDEN,
      DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT
      AUCH F&Uuml;R EIN AUF DIESE BESTIMMUNGEN GEST&Uuml;TZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT,
      ENTNEHMEN SIE DIESER DATENSCHUTZERKL&Auml;RUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT
      MEHR VERARBEITEN, ES SEI DENN, WIR K&Ouml;NNEN ZWINGENDE SCHUTZW&Uuml;RDIGE GR&Uuml;NDE F&Uuml;R DIE VERARBEITUNG NACHWEISEN, DIE IHRE
      INTERESSEN, RECHTE UND FREIHEITEN &Uuml;BERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUS&Uuml;BUNG ODER VERTEIDIGUNG VON
      RECHTSANSPR&Uuml;CHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
    </p>
    <p>
      WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE
      VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH F&Uuml;R DAS PROFILING,
      SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT
      MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
    </p>
    <h5>Beschwerde&shy;recht bei der zust&auml;ndigen Aufsichts&shy;beh&ouml;rde</h5>
    <p>
      Im Falle von Verst&ouml;&szlig;en gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbeh&ouml;rde,
      insbesondere in dem Mitgliedstaat ihres gew&ouml;hnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutma&szlig;lichen
      Versto&szlig;es zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
    </p>
    <h5>Recht auf Daten&shy;&uuml;bertrag&shy;barkeit</h5>
    <p>
      Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf&uuml;llung eines Vertrags automatisiert verarbeiten, an
      sich oder an einen Dritten in einem g&auml;ngigen, maschinenlesbaren Format aush&auml;ndigen zu lassen. Sofern Sie die direkte
      &Uuml;bertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
    </p>
    <h5>Auskunft, Berichtigung und L&ouml;schung</h5>
    <p>
      Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft &uuml;ber Ihre gespeicherten
      personenbezogenen Daten, deren Herkunft und Empf&auml;nger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder
      L&ouml;schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k&ouml;nnen Sie sich jederzeit an uns
      wenden.
    </p>
    <h5>Recht auf Einschr&auml;nkung der Verarbeitung</h5>
    <p>
      Sie haben das Recht, die Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Hierzu k&ouml;nnen Sie sich
      jederzeit an uns wenden. Das Recht auf Einschr&auml;nkung der Verarbeitung besteht in folgenden F&auml;llen:
    </p>
    <ul>
      <li>
        Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, ben&ouml;tigen wir in der Regel Zeit, um dies
        zu &uuml;berpr&uuml;fen. F&uuml;r die Dauer der Pr&uuml;fung haben Sie das Recht, die Einschr&auml;nkung der Verarbeitung Ihrer
        personenbezogenen Daten zu verlangen.
      </li>
      <li>
        Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtm&auml;&szlig;ig geschah/geschieht, k&ouml;nnen Sie statt der L&ouml;schung
        die Einschr&auml;nkung der Datenverarbeitung verlangen.
      </li>
      <li>
        Wenn wir Ihre personenbezogenen Daten nicht mehr ben&ouml;tigen, Sie sie jedoch zur Aus&uuml;bung, Verteidigung oder Geltendmachung
        von Rechtsanspr&uuml;chen ben&ouml;tigen, haben Sie das Recht, statt der L&ouml;schung die Einschr&auml;nkung der Verarbeitung Ihrer
        personenbezogenen Daten zu verlangen.
      </li>
      <li>
        Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abw&auml;gung zwischen Ihren und unseren Interessen
        vorgenommen werden. Solange noch nicht feststeht, wessen Interessen &uuml;berwiegen, haben Sie das Recht, die Einschr&auml;nkung der
        Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
      </li>
    </ul>
    <p>
      Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschr&auml;nkt haben, d&uuml;rfen diese Daten &ndash; von ihrer Speicherung
      abgesehen &ndash; nur mit Ihrer Einwilligung oder zur Geltendmachung, Aus&uuml;bung oder Verteidigung von Rechtsanspr&uuml;chen oder zum
      Schutz der Rechte einer anderen nat&uuml;rlichen oder juristischen Person oder aus Gr&uuml;nden eines wichtigen &ouml;ffentlichen
      Interesses der Europ&auml;ischen Union oder eines Mitgliedstaats verarbeitet werden.
    </p>
    <h5>4. Datenerfassung auf dieser Website</h5>
    <h5>Anfrage per E-Mail, Telefon oder Telefax</h5>
    <p>
      Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen
      Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne
      Ihre Einwilligung weiter.
    </p>
    <p>
      Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erf&uuml;llung eines
      Vertrags zusammenh&auml;ngt oder zur Durchf&uuml;hrung vorvertraglicher Ma&szlig;nahmen erforderlich ist. In allen &uuml;brigen
      F&auml;llen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen
      (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist
      jederzeit widerrufbar.
    </p>
    <p>
      Die von Ihnen an uns per Kontaktanfragen &uuml;bersandten Daten verbleiben bei uns, bis Sie uns zur L&ouml;schung auffordern, Ihre
      Einwilligung zur Speicherung widerrufen oder der Zweck f&uuml;r die Datenspeicherung entf&auml;llt (z.&nbsp;B. nach abgeschlossener
      Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen &ndash; insbesondere gesetzliche Aufbewahrungsfristen &ndash; bleiben
      unber&uuml;hrt.
    </p>
    <h5>5. Plugins und Tools</h5>
    <h5>Google Fonts</h5>
    <p>
      Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Google Fonts, die von Google bereitgestellt werden. Beim
      Aufruf einer Seite l&auml;dt Ihr Browser die ben&ouml;tigten Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.
    </p>
    <p>
      Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google aufnehmen. Hierdurch erlangt Google Kenntnis
      dar&uuml;ber, dass &uuml;ber Ihre IP-Adresse diese Website aufgerufen wurde. Die Nutzung von Google Fonts erfolgt auf Grundlage von Art.
      6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der einheitlichen Darstellung des Schriftbildes auf seiner
      Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie&szlig;lich auf Grundlage von Art. 6
      Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen
      im Endger&auml;t des Nutzers (z.&nbsp;B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
    </p>
    <p>Wenn Ihr Browser Google Fonts nicht unterst&uuml;tzt, wird eine Standardschrift von Ihrem Computer genutzt.</p>
    <p>
      Weitere Informationen zu Google Fonts finden Sie unter
      <a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener noreferrer">https://developers.google.com/fonts/faq</a>
      und in der Datenschutzerkl&auml;rung von Google:
      <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer"
      >https://policies.google.com/privacy?hl=de</a
      >.
    </p>

    <h5>Speicherung von Kundendaten bei Stripe und Firebase</h5>
    <p>
      Wenn Sie über Stripe eine Zahlung auf unserer Website vornehmen, werden wir Ihren Namen und Ihre E-Mail-Adresse speichern. Diese
      Daten werden in unserer Firebase-Datenbank zur Verwaltung Ihrer Bestellung und zur Kommunikation mit Ihnen gespeichert.
      Weitere Daten, wie zum Beispiel Ihre Rechnungsadresse, werden nur von Stripe verarbeitet und nicht von uns gespeichert.
    </p>
    <p>
      Weitere Informationen zur Datenschutz­verarbeitung durch Stripe finden Sie in deren Datenschutzerklärung:
      <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer">Stripe Privacy Policy</a>.
    </p>

    <h5>6. Datenerfassung auf dieser Website</h5>

    <h5>Verschlüsselter Zahlungsverkehr auf der Website</h5>

    <p>
      <strong>Zahlungsdaten</strong><br />
      Zur Durchführung von Zahlungen auf unserer Website verwenden wir den Zahlungsdienstleister Stripe. Alle Zahlungen werden über eine
      verschlüsselte Verbindung (SSL/TLS) abgewickelt, um Ihre sensiblen Zahlungsinformationen zu schützen. Die von Ihnen eingegebenen
      Zahlungsdaten werden nur im Rahmen der Zahlungsabwicklung und im Einklang mit den Datenschutzbestimmungen von Stripe verarbeitet.
    </p>

    <p>
      Weitere Informationen zur Datenschutz­verarbeitung durch Stripe finden Sie in deren Datenschutzerklärung:
      <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer">Stripe Privacy Policy</a>.
    </p>

    <h5>Kommunikation via WhatsApp</h5>

    <p>
      <strong>Verwendung von WhatsApp</strong><br />
      Wir bieten Ihnen die Möglichkeit, über WhatsApp mit uns zu kommunizieren. Wenn Sie diesen Kommunikationsweg nutzen, werden die von Ihnen
      übermittelten Daten (z. B. Telefonnummer, Name, Nachrichten) von WhatsApp verarbeitet. Wir speichern diese Daten nur, um mit Ihnen in
      Kontakt zu treten und Ihre Anfrage zu bearbeiten. WhatsApp verarbeitet Daten in Übereinstimmung mit den eigenen Datenschutzrichtlinien,
      die Sie hier einsehen können:
      <a href="https://www.whatsapp.com/legal" target="_blank" rel="noopener noreferrer">WhatsApp Privacy Policy</a>.
    </p>

    <p>
      Die Nutzung von WhatsApp erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), die Sie jederzeit widerrufen können.
    </p>

    <h5>Kommunikation via Telegram</h5>

    <p>
      <strong>Verwendung von Telegram</strong><br />
      Wir bieten Ihnen auch die Möglichkeit, über Telegram mit uns zu kommunizieren. Wenn Sie diesen Kommunikationsweg nutzen, werden die von
      Ihnen übermittelten Daten (z. B. Telefonnummer, Name, Nachrichten) von Telegram verarbeitet. Wir speichern diese Daten nur, um mit Ihnen
      in Kontakt zu treten und Ihre Anfrage zu bearbeiten. Telegram verarbeitet Daten gemäß den eigenen Datenschutzbestimmungen, die Sie hier
      einsehen können: <a href="https://telegram.org/privacy" target="_blank" rel="noopener noreferrer">Telegram Privacy Policy</a>.
    </p>

    <p>
      Die Nutzung von Telegram erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), die Sie jederzeit widerrufen können.
    </p>

    <h5>Zahlungsdienste – Nutzung von Stripe</h5>

    <p>
      <strong>Zahlungsabwicklung mit Stripe</strong><br />
      Für die Abwicklung von Zahlungen auf unserer Website setzen wir den Zahlungsdienstleister Stripe ein. Stripe verarbeitet
      personenbezogene Daten, die für die Durchführung der Zahlungen erforderlich sind, wie z. B. Zahlungsdaten, Rechnungsadresse und ggf.
      andere relevante Informationen. Stripe erhebt, speichert und verarbeitet diese Daten in Übereinstimmung mit den eigenen
      Datenschutzrichtlinien, die Sie hier einsehen können:
      <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer">Stripe Privacy Policy</a>.
    </p>

    <p>
      Die Nutzung von Stripe erfolgt auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO zur Durchführung des Zahlungsprozesses im Rahmen unserer
      vertraglichen Leistungen. Eine Weitergabe von Daten erfolgt nur, soweit dies zur Zahlungsabwicklung erforderlich ist.
    </p>

    <p>
      Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem &bdquo;EU-US Data Privacy Framework&ldquo; (DPF). Der DPF ist ein
      &Uuml;bereinkommen zwischen der Europ&auml;ischen Union und den USA, der die Einhaltung europ&auml;ischer Datenschutzstandards bei
      Datenverarbeitungen in den USA gew&auml;hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese
      Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link:
      <a href="https://www.dataprivacyframework.gov/participant/5780" target="_blank" rel="noopener noreferrer"
      >https://www.dataprivacyframework.gov/participant/5780</a
      >.
    </p>

    <div class="row justify-center">
      <q-btn
          no-caps
          flat
          size="lg"
          color="primary"
          label="Zrück"
          icon="arrow_back_ios"
          @click="router.back()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

</script>
